import { Model } from 'pinia-orm';
import Company from './Company';
import Tag from './Tag';
import CompetenceTag from './CompetenceTag';
import ApplicationCompetence from './ApplicationCompetence';
import JobCompetence from './JobCompetence';

export default class Competence extends Model {

    static get entity() {
        return 'competences';
    }

    static fields() {
        return {
            id: this.uid(),
            title: this.attr({}),
            description: this.attr({}),
            company_id: this.attr(null),
            used: this.boolean(false),
            order: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            company: this.belongsTo(Company, 'company_id'),
            tags: this.belongsToMany(Tag, CompetenceTag, 'competence_id', 'tag_id'),
            application_competences: this.hasMany(ApplicationCompetence, 'competence_id'),
            job_competences: this.hasMany(JobCompetence, 'competence_id'),
            // competence_templates: this.belongsToMany(CompetenceTemplate, CompetenceTemplateCompetence, 'competence_template_id', 'competence_id'),
        }
    }
}
